import { render, staticRenderFns } from "./TextMatchItem.vue?vue&type=template&id=4bfccd42&scoped=true&"
import script from "./TextMatchItem.vue?vue&type=script&lang=ts&"
export * from "./TextMatchItem.vue?vue&type=script&lang=ts&"
import style0 from "./TextMatchItem.vue?vue&type=style&index=0&id=4bfccd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfccd42",
  null
  
)

export default component.exports